import { ReduxState } from 'src/store/types';

export const catalogDatabaseSelector = (state: ReduxState) => {
  const connectionId = state.connections.connection?.id;
  const { catalogDatabaseByConnectionId } = state.connections;
  return catalogDatabaseByConnectionId[connectionId || ''] || 'catalog';
};
